import { createActionGroup, props } from '@ngrx/store';
import { CalificacionDetalle } from './calificaciones.state';

export const CalificacionesActions = createActionGroup({
  source: 'Calificaciones',
  events: {
    'Load Grades': props<{ studentId: string }>(),
    'Load Grades Success': props<{ grades: CalificacionDetalle[] }>(),
    'Load Grades Failure': props<{ error: string }>(),
  },
});
